import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { useKSK2080_R01Store } from "./Store_KSK2080_R01";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { useState } from "react";



export const SearchSection_KSK2080_R01 = () => {

  const { KSK2080_R01Filter, setKSK2080_R01Filter } = useKSK2080_R01Store();

  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
	<SearchSectionForm>
		
		<SearchDateRangeForm
				label="게시 기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={KSK2080_R01Filter.dateRange}		setDateRange={(dateRange) => setKSK2080_R01Filter({ dateRange })}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
			/>
		
	</SearchSectionForm>
  )
}